import { render, staticRenderFns } from "./BaseLandingPageEditor.vue?vue&type=template&id=b4092586"
import script from "./BaseLandingPageEditor.vue?vue&type=script&lang=js"
export * from "./BaseLandingPageEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports